import { render, staticRenderFns } from "./CompanyDataUpdateDetailsMessages.vue?vue&type=template&id=1ea4ae58&scoped=true&"
import script from "./CompanyDataUpdateDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea4ae58",
  null
  
)

export default component.exports